export default "__VITE_ASSET__padQnSZ0__"